import CanvasJSReact from "@canvasjs/react-charts";
import { renderEUDateTime } from "../../../../utils/utils";
import dayjs from "dayjs";
import { parseTemperatureReports } from "./temperatureReport";
import { parsePressureReports } from "./pressureReport";
import { parseSPO2Reports } from "./spo2Report";

export function orderByDate(arr) {
  return arr.sort((a, b) => new Date(a.x) - new Date(b.x));
}

export function generateMixedChart(
  pressureReports,
  spo2Reports,
  temperatureReports,
  small = false,
) {
  // temperature - asse y primario
  let datapoints = parseTemperatureReports(temperatureReports);
  datapoints = orderByDate(datapoints);

  const AxisX = {
    labelFontSize: small ? 10 : 16,
    labelMaxWidth: small ? 45 : 60,
    stripLines: [],
    gridThickness: 0,
    labelTextAlign: "center",
    labelFormatter: function (e) {
      return CanvasJSReact.CanvasJS.formatDate(e.label, "DD/MM YYYY HH:mm");
    },
  };

  const tData = {
    type: "spline",
    color: "#f99",
    markerColor: "#ff0000",
    name: "Temperatura",
    showInLegend: true,
    dataPoints: datapoints.map((el) => {
      return {
        label: el.x, //date,
        y: el.y,
      };
    }),
  };

  // pressure
  let { datapointsPmax, datapointsPmin, datapointsHR } =
    parsePressureReports(pressureReports);
  datapointsPmax = orderByDate(datapointsPmax);
  datapointsPmin = orderByDate(datapointsPmin);
  datapointsHR = orderByDate(datapointsHR);

  const pAxisY = {
    gridThickness: 0.6,
    titleFontSize: small ? 10 : 16,
    labelFontSize: small ? 10 : 16,
    title: "Pressione",
    lineColor: "#C24642",
    titleFontColor: "#C24642",
    labelFontColor: "#C24642",
  };

  const pData = [
    {
      name: "Press. Massima",
      type: "spline",
      showInLegend: true,
      legendMarkerType: "square",
      color: "#b7e1b7",
      axisYType: "primary",
      markerColor: "#139d13",
      dataPoints: datapointsPmax.map((el) => {
        return {
          label: el.x, // date,
          y: el.y,
        };
      }),
    },
    {
      name: "Press. Minima",
      type: "spline",
      showInLegend: true,
      legendMarkerType: "square",
      color: "#4a79a0",
      markerColor: "#43739f",
      dataPoints: datapointsPmin.map((el) => {
        return {
          label: el.x, // date,
          y: el.y,
        };
      }),
      axisYType: "primary",
    },
    {
      name: "Freq. Cardiaca",
      type: "spline",
      showInLegend: true,
      legendMarkerType: "square",
      color: "#8e5948",
      lineColor: "#8e5948",
      dataPoints: datapointsHR.map((el) => {
        return {
          label: el.x, // date,
          y: el.y,
        };
      }),
      axisYType: "primary",
    },
  ];

  // spo2
  let { datapointsSPO2, _datapointsHR } = parseSPO2Reports(spo2Reports);
  datapointsSPO2 = orderByDate(datapointsSPO2);
  const sAxisY = {
    gridThickness: 0.6,
    // title: "Ossigenazione",
    lineColor: "#7F6084",
    titleFontSize: small ? 10 : 16,
    labelFontSize: small ? 10 : 16,
    // titleFontColor: "#7F6084",
    // labelFontColor: "#7F6084",
  };

  const sData = {
    axisYType: "primary",
    name: "SPO2 Media",
    type: "spline",
    showInLegend: true,
    legendMarkerType: "square",
    color: "#7F6084",
    markerColor: "#7F6084",
    dataPoints: datapointsSPO2.map((el) => {
      return {
        label: el.x, //date,
        y: el.y,
      };
    }),
  };

  let layout = {
    theme: "light2",
    animationEnabled: !small,
    margin: 0,

    legend: {
      dockInsidePlotArea: false,
      cursor: "pointer",
      horizontalAlign: "center",
      verticalAlign: "top",
      fontSize: small ? 10 : 16,
      fontColor: "dimGrey",
      itemclick: small
        ? null
        : function (e) {
            if (
              typeof e.dataSeries.visible === "undefined" ||
              e.dataSeries.visible
            ) {
              e.dataSeries.visible = false;
            } else {
              e.dataSeries.visible = true;
            }

            e.chart.render();
          },
    },
    toolTip: small
      ? null
      : {
          shared: true,
        },
    axisY: sAxisY,
    // tAxisY,
    // axisY2: tAxisY,
    axisX: AxisX,
    data: [...pData, tData, sData],
  };

  return layout;
}
